// // src/components/Sidebar.jsx
// import React, { useState, useEffect } from 'react';
// import { useAuth } from '../contexts/AuthContext';
// import api from '../services/api';

// const Sidebar = ({ currentTab, setCurrentTab, isOpen, onClose }) => {
//   const { logout } = useAuth();
//   const [checklist, setChecklist] = useState({});

//   useEffect(() => {
//     // Poll stats to display checkmarks next to tasks dynamically
//     const fetchStats = async () => {
//       try {
//         const res = await api.get('/dashboard/employee');
//         if (res.data && res.data.checklist) {
//           setChecklist(res.data.checklist);
//         }
//       } catch (err) {
//         // Fail silently
//       }
//     };
//     fetchStats();
//     // Run every time currentTab changes to refresh checkmarks
//   }, [currentTab]);

//   const links = [
//     { id: 'dashboard', label: 'Dashboard', key: 'dashboard', icon: '📊' },
//     { id: 'personal', label: 'Personal Information', key: 'personal_info', icon: '👤' },
//     { id: 'contacts', label: 'Emergency Contacts', key: 'emergency_contacts', icon: '📞' },
//     { id: 'documents', label: 'Documents', key: 'documents', icon: '📁' },
//     { id: 'offer', label: 'Offer Letter', key: 'offer', icon: '📄' },
//     { id: 'agreement', label: 'Employee Agreement', key: 'agreement', icon: '📝' },
//     { id: 'policies', label: 'Company Policies', key: 'policies', icon: '⚖️' },
//     // { id: 'tax', label: 'Tax Information', key: 'tax_info', icon: '💵' },
//     { id: 'bank', label: 'Bank Details', key: 'bank_details', icon: '🏦' },
//     { id: 'photo', label: 'Profile Photo', key: 'profile_photo', icon: '📷' },
//     { id: 'submit', label: 'Review & Submit', key: 'submit', icon: '🚀' }
//   ];

//   return (
//     <div className={`sidebar ${isOpen ? 'open' : ''}`}>
//       <div className="sidebar-logo">
//         <img 
//           src={process.env.PUBLIC_URL + '/gtelinq_logo.png'} 
//           alt="GTELINQ Logo" 
//           style={{ 
//             maxHeight: '42px', 
//             maxWidth: '100%', 
//             objectFit: 'contain',
//             transition: 'transform 0.2s ease-in-out'
//           }}
//           onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
//           onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
//         />
//       </div>

//       <ul className="sidebar-menu">
//         {links.map((link) => (
//           <li className="sidebar-item" key={link.id}>
//             <div
//               className={`sidebar-link ${currentTab === link.id ? 'active' : ''}`}
//               onClick={() => setCurrentTab(link.id)}
//               style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
//             >
//               <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//                 <span style={{ fontSize: '1.1rem' }}>{link.icon}</span>
//                 {link.label}
//               </span>
//               {/* Show checkmark if complete (excluding welcome page) */}
//               {link.id !== 'dashboard' && link.id !== 'submit' && checklist[link.key] && (
//                 <span style={{ color: 'var(--success)', fontWeight: 'bold' }}>✓</span>
//               )}
//             </div>
//           </li>
//         ))}
//       </ul>

//       <div className="sidebar-footer">
//         <button
//           onClick={logout}
//           className="btn btn-secondary"
//           style={{ width: '100%', fontSize: '0.85rem', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.25rem' }}
//           type="button"
//         >
//           🚪 Logout
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;



















// // src/components/Sidebar.jsx
// import React, { useState, useEffect } from 'react';
// import { useAuth } from '../contexts/AuthContext';
// import api from '../services/api';

// const Sidebar = ({ currentTab, setCurrentTab, isOpen, onClose }) => {
//   const { logout } = useAuth();
//   const [checklist, setChecklist] = useState({});

//   useEffect(() => {
//     // Poll stats to display checkmarks next to tasks dynamically
//     const fetchStats = async () => {
//       try {
//         const res = await api.get('/dashboard/employee');
//         const onboardingRes = await api.get('/onboarding');
//         if (res.data && res.data.checklist) {
//           const profile = onboardingRes.data?.profile || {};
//           const documents = onboardingRes.data?.documents || [];
//           const passportDoc = documents.find(d => d.document_type === 'Passport Size Photo');
//           const rawPath = profile?.profile_photo_path;
//           const isPassportMatch = (
//             (passportDoc?.file_path && rawPath === passportDoc.file_path) ||
//             (rawPath && documents.some(doc => doc.document_type === 'Passport Size Photo' && doc.file_path === rawPath))
//           );
//           const hasBadgePhoto = !!(rawPath && !isPassportMatch);

//           setChecklist({
//             ...res.data.checklist,
//             profile_photo: hasBadgePhoto
//           });
//         }
//       } catch (err) {
//         // Fail silently
//       }
//     };
//     fetchStats();
//     // Run every time currentTab changes to refresh checkmarks
//   }, [currentTab]);

//   const links = [
//     { id: 'dashboard', label: 'Dashboard', key: 'dashboard', icon: '📊' },
//     { id: 'personal', label: 'Personal Information', key: 'personal_info', icon: '👤' },
//     { id: 'contacts', label: 'Emergency Contacts', key: 'emergency_contacts', icon: '📞' },
//     { id: 'documents', label: 'Documents', key: 'documents', icon: '📁' },
//     { id: 'offer', label: 'Offer Letter', key: 'offer', icon: '📄' },
//     { id: 'agreement', label: 'Employee Agreement', key: 'agreement', icon: '📝' },
//     { id: 'policies', label: 'Company Policies', key: 'policies', icon: '⚖️' },
//     // { id: 'tax', label: 'Tax Information', key: 'tax_info', icon: '💵' },
//     { id: 'bank', label: 'Bank Details', key: 'bank_details', icon: '🏦' },
//     { id: 'photo', label: 'Profile Photo', key: 'profile_photo', icon: '📷' },
//     { id: 'submit', label: 'Review & Submit', key: 'submit', icon: '🚀' }
//   ];

//   return (
//     <div className={`sidebar ${isOpen ? 'open' : ''}`}>
//       <div className="sidebar-logo">
//         <img
//           src={process.env.PUBLIC_URL + '/gtelinq_logo.png'}
//           alt="GTELINQ Logo"
//           style={{
//             maxHeight: '42px',
//             maxWidth: '100%',
//             objectFit: 'contain',
//             transition: 'transform 0.2s ease-in-out'
//           }}
//           onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
//           onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
//         />
//       </div>

//       <ul className="sidebar-menu">
//         {links.map((link) => (
//           <li className="sidebar-item" key={link.id}>
//             <div
//               className={`sidebar-link ${currentTab === link.id ? 'active' : ''}`}
//               onClick={() => setCurrentTab(link.id)}
//               style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
//             >
//               <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
//                 <span style={{ fontSize: '1.1rem' }}>{link.icon}</span>
//                 {link.label}
//               </span>
//               {/* Show checkmark if complete (excluding welcome page) */}
//               {link.id !== 'dashboard' && link.id !== 'submit' && checklist[link.key] && (
//                 <span style={{ color: 'var(--success)', fontWeight: 'bold' }}>✓</span>
//               )}
//             </div>
//           </li>
//         ))}
//       </ul>

//       <div className="sidebar-footer">
//         <button
//           onClick={logout}
//           className="btn btn-secondary"
//           style={{ width: '100%', fontSize: '0.85rem', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.25rem' }}
//           type="button"
//         >
//           🚪 Logout
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;


























// src/components/Sidebar.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

const Sidebar = ({ currentTab, setCurrentTab, isOpen, onClose }) => {
  const { logout } = useAuth();
  const [checklist, setChecklist] = useState({});

  useEffect(() => {
    // Fetch stats to display checkmarks next to tasks dynamically
    const fetchStats = async () => {
      try {
        const res = await api.get('/dashboard/employee');
        const onboardingRes = await api.get('/onboarding');
        if (res.data && res.data.checklist) {
          const profile = onboardingRes.data?.profile || {};
          const documents = onboardingRes.data?.documents || [];
          const passportDoc = documents.find(d => d.document_type === 'Passport Size Photo');
          const rawPath = profile?.profile_photo_path;
          const isPassportMatch = (
            (passportDoc?.file_path && rawPath === passportDoc.file_path) ||
            (rawPath && documents.some(doc => doc.document_type === 'Passport Size Photo' && doc.file_path === rawPath))
          );
          const hasBadgePhoto = !!(rawPath && !isPassportMatch);

          setChecklist({
            ...res.data.checklist,
            profile_photo: hasBadgePhoto
          });
        }
      } catch (err) {
        // Fail silently
      }
    };
    fetchStats();

    const handleUpdate = () => {
      fetchStats();
    };

    window.addEventListener('onboarding_updated', handleUpdate);
    return () => {
      window.removeEventListener('onboarding_updated', handleUpdate);
    };
  }, [currentTab]);

  const links = [
    { id: 'dashboard', label: 'Dashboard', key: 'dashboard', icon: '📊' },
    { id: 'personal', label: 'Personal Information', key: 'personal_info', icon: '👤' },
    { id: 'contacts', label: 'Emergency Contacts', key: 'emergency_contacts', icon: '📞' },
    { id: 'documents', label: 'Documents', key: 'documents', icon: '📁' },
    { id: 'offer', label: 'Offer Letter', key: 'offer', icon: '📄' },
    { id: 'agreement', label: 'Employee Agreement', key: 'agreement', icon: '📝' },
    { id: 'policies', label: 'Company Policies', key: 'policies', icon: '⚖️' },
    // { id: 'tax', label: 'Tax Information', key: 'tax_info', icon: '💵' },
    { id: 'bank', label: 'Bank Details', key: 'bank_details', icon: '🏦' },
    { id: 'photo', label: 'Profile Photo', key: 'profile_photo', icon: '📷' },
    { id: 'submit', label: 'Review & Submit', key: 'submit', icon: '🚀' }
  ];

  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-logo">
        <img
          src={process.env.PUBLIC_URL + '/gtelinq_logo.png'}
          alt="GTELINQ Logo"
          style={{
            maxHeight: '42px',
            maxWidth: '100%',
            objectFit: 'contain',
            transition: 'transform 0.2s ease-in-out'
          }}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
        />
      </div>

      <ul className="sidebar-menu">
        {links.map((link) => (
          <li className="sidebar-item" key={link.id}>
            <div
              className={`sidebar-link ${currentTab === link.id ? 'active' : ''}`}
              onClick={() => setCurrentTab(link.id)}
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
            >
              <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span style={{ fontSize: '1.1rem' }}>{link.icon}</span>
                {link.label}
              </span>
              {/* Show checkmark if complete (excluding welcome page) */}
              {link.id !== 'dashboard' && link.id !== 'submit' && checklist[link.key] && (
                <span style={{ color: 'var(--success)', fontWeight: 'bold' }}>✓</span>
              )}
            </div>
          </li>
        ))}
      </ul>

      <div className="sidebar-footer">
        <button
          onClick={logout}
          className="btn btn-secondary"
          style={{ width: '100%', fontSize: '0.85rem', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.25rem' }}
          type="button"
        >
          🚪 Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
